import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';

import { SeasonFormComponent } from '../season-form/season-form.component';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs';
import { LoadSeason } from '../../../state/season/season.action';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-season-edit',
    imports: [SeasonFormComponent],
    host: { class: 'block h-full' },
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        @if (seasonId()) {
            <app-season-form mode="edit"></app-season-form>
        }
    `
})
export class SeasonEditComponent {
    private route = inject(ActivatedRoute);
    private store = inject(Store);

    protected seasonId = toSignal(this.route.params.pipe(map(params => params['seasonId'] as string | null)));

    constructor() {
        effect(() => {
            const id = this.seasonId();
            if (id) {
                this.store.dispatch(new LoadSeason({ seasonId: id }));
            }
        });
    }
}
